"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useColorSchemePreference = void 0;
var _react = require("react");
var useColorSchemePreference = function useColorSchemePreference(initialThemeSet, listenerCallback) {
  // System Theme Preference Managment
  (0, _react.useEffect)(function () {
    // get current light/dark mode value
    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      initialThemeSet();
    }

    // listen for changes in real time
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (event) {
      listenerCallback(event);
    });
    return function () {
      window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', function (event) {
        listenerCallback(event);
      });
    };
  }, []);
};
exports.useColorSchemePreference = useColorSchemePreference;